<template>
  <m-layout>
    <div fill-height class="fill-height" style="width:100%">
    <m-todo></m-todo>
    </div>
  </m-layout>
</template>

<script>
import Todo from '@/components/todo/todo';

export default {
  name: 'Todo',
  components: {
    'm-todo': Todo
  }
}
</script>

<style lang="scss">

</style>
